//
//
//

import { sendTmhfLog } from '@/_base/log'
const HZ = {
    10702: 'https://hpgaqm5pyq.720yun.com/vr/1ef25mbO91v',
    5981: 'https://hpgaqm5pyq.720yun.com/vr/56321mpkwli',
    6481: 'https://hpgaqm5pyq.720yun.com/vr/aa625js8qyw',
    6516: 'https://hpgaqm5pyq.720yun.com/vr/9bd20js5jnr',
    7468: 'https://hpgaqm5pyq.720yun.com/vr/bcc2empkybi',
    7697: 'https://hpgaqm5pyq.720yun.com/vr/df52bj8u9lv',
    7706: 'https://hpgaqm5pyq.720yun.com/vr/e742ajpkxtf',
    7720: 'https://hpgaqm5pyq.720yun.com/vr/6b927jsduc6',
    7726: 'https://hpgaqm5pyq.720yun.com/vr/e6826jpkx4f',
    7729: 'https://hpgaqm5pyq.720yun.com/vr/8b02djsgqln',
    7733: 'https://hpgaqm5pyq.720yun.com/vr/69929mpkwtw',
    7735: 'https://hpgaqm5pyq.720yun.com/vr/6202fjp5yn6',
    8239: 'https://hpgaqm5pyq.720yun.com/vr/6ce27j8kaba',
    8254: 'https://hpgaqm5pyq.720yun.com/vr/cb022jO591v',
    8605: 'https://hpgaqm5pyq.720yun.com/vr/3cf2fjsu94a',
    8607: 'https://hpgaqm5pyq.720yun.com/vr/8c828mi8m4g',
    8609: 'https://hpgaqm5pyq.720yun.com/vr/2b524mpvybw',
    8613: 'https://hpgaqm5pyq.720yun.com/vr/1bc23j8u91i',
    8614: 'https://hpgaqm5pyq.720yun.com/vr/27226j8fcbs',
    8619: 'https://hpgaqm5pyq.720yun.com/vr/82124jO59ui',
    8620: 'https://hpgaqm5pyq.720yun.com/vr/2f12ej8fwef',
    8623: 'https://hpgaqm5pyq.720yun.com/vr/fcb2ajsu9uw',
    8632: 'https://hpgaqm5pyq.720yun.com/vr/43321jfgjea',
    8634: 'https://hpgaqm5pyq.720yun.com/vr/8642fj86q4a',
    8635: 'https://hpgaqm5pyq.720yun.com/vr/f0223mpkylw',
    8636: 'https://hpgaqm5pyq.720yun.com/vr/4bd28mf6qea',
    10729: 'https://hpgaqm5pyq.720yun.com/vr/2b724mbO9yv'
}

const CONFIG = {
    hz: HZ
}

export default {
    data() {
        return {
            url: ''
        }
    },
    mounted() {
        sendTmhfLog(this.$route.path, this.$route.query)
        const { city } = this.$route.params
        const { building_id } = this.$route.query
        console.log('city', this.$route)
        this.url = CONFIG[city][building_id] || ''
    }
}
